import React from 'react';
import styles from './ProductCard.module.css';
import { buildWhatsAppOrderUrl } from '../utils/whatsapp';

const ProductCard = ({ product, onAddToCart, onItemClick, cartList = [] }) => {
  // Count occurrences of this product in cartList
  const productCount = cartList.reduce((count, item) => {
    return count + (item.item_id === product.item_id ? (item.quantity || 1) : 0);
  }, 0);

  const handleAddToCartClick = (e) => {
    e.stopPropagation();
    onAddToCart(product);
  };

  const handleWhatsAppClick = (e) => {
    e.stopPropagation();
    window.open(buildWhatsAppOrderUrl(product), '_blank', 'noopener,noreferrer');
  };

  const getImageSrc = () => {
    if (!product.photo_url) return '';
    if (product.photo_url.startsWith('http') || product.photo_url.startsWith('/')) {
      return product.photo_url;
    }
    if (product.photo_url.startsWith('img/') || product.photo_url.startsWith('./img/')) {
      return `/${product.photo_url.replace(/^\.\//, '')}`;
    }
    return `/img/${product.photo_url}`;
  };

  return (
    <div className={styles.card} onClick={() => onItemClick && onItemClick(product)} role="button" tabIndex={0} onKeyPress={() => onItemClick && onItemClick(product)}>
      {product.sale > 0 && (
        <div className={styles.saleBadge}>
          Sale {product.sale}%
        </div>
      )}
      <div className={styles.brand}>{product.brand}</div>
      <div className={styles.imageWrapper}>
        <img
          src={getImageSrc()}
          alt={product.item_name}
          className={styles.productImage}
          draggable={false}
        />
      </div>
      <div className={styles.productName}>{product.item_name}</div>
      <div className={styles.dimen}>{product.dimen}</div>
      {product.sell_price > 0 && (
        <div className={styles.priceContainer}>
          <span>${product.sell_price}</span>
          {product.old_price && product.old_price !== 0 ? (
            <span className={styles.oldPrice}>${product.old_price}</span>
          ) : null}
        </div>
      )}
      {productCount > 0 && (
        <span className={styles.cartCountBadge}>
          {productCount}
        </span>
      )}
      <div className={styles.buttonRow}>
        <button
          onClick={handleWhatsAppClick}
          className={`${styles.addToCartButton} ${styles.whatsappButton}`}
          type="button"
          aria-label={`Order ${product.item_name} on WhatsApp`}
        >
          <i className="fa fa-whatsapp" aria-hidden="true"></i> WhatsApp
        </button>
        <button
          onClick={handleAddToCartClick}
          className={`${styles.addToCartButton} ${styles.cartIconButton}`}
          type="button"
          aria-label={`Add ${product.item_name} to cart`}
        >
          <i className="fa fa-shopping-cart" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
